import React, { useState, useEffect } from 'react'
import {
  Container,
  Card,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import { FaSyncAlt } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'

export default function ApplyFees() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { student_id, course_id } = useParams()
  console.log('STUDENT ID: ', student_id)
  // const [feeStructureData, setFeeStructureData] = useState([])
  const [selectedCourse, setSelectedCourse] = useState('')
  const [selectedStudent, setSelectedStudent] = useState('')
  const [selectedFeeStructure, setSelectedFeeStructure] = useState('')
  const [isAcknowledged, setIsAcknowledged] = useState(false)
  const navigate = useNavigate()
  const [classes, setClasses] = useState([])
  const [courses, setCourses] = useState([])
  const [students, setStudents] = useState([])
  const [feeStructure, setFeeStructure] = useState([])
  const [currentStudent, setCurrentStudent] = useState(null)
  const [discount, setDiscount] = useState('')
  const [filteredCourse, setFilteredCourse] = useState([])

  useEffect(() => {
    if (course_id) {
      setSelectedCourse(Number(course_id))
    }
  }, [course_id])

  useEffect(() => {
    if (students.length > 0 && student_id) {
      const student = students.find((s) => s.id === parseInt(student_id))
      if (student) {
        setSelectedStudent(student.id)
        setCurrentStudent(student)

        // Also select the corresponding fee structure
        const matchedFees = feeStructure.find(
          (fee) => fee.object_id === student.course_id,
        )
        setSelectedFeeStructure(matchedFees || null)
      }
    }
  }, [students, student_id, feeStructure])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      console.log('📌 All Courses:', res.data.data)
      setCourses(res.data.data)
    })

    // ApiEndpoints.getAllStudents().then((res) => {
    //   console.log('📌 All Students:', res.data.data)
    //   setStudents(res.data.data)
    // })
    ApiEndpoints.getAllFees().then((res) => {
      console.log('📌 All Fee Structure:', res.data.data)
      setFeeStructure(res.data.data)
    })
    ApiEndpoints.getAllClasses().then((res) => {
      console.log('📌 All classes:', res.data.data)
      setClasses(res.data.data)
    })
  }, [])

  useEffect(() => {
    if (
      student_id &&
      students.length > 0 &&
      course_id &&
      courses.length > 0 &&
      feeStructure.length > 0
    ) {
      const student = students.find((s) => s.id === parseInt(student_id))
      if (student) {
        setSelectedStudent(student.id)
        setCurrentStudent(student)
        setSelectedCourse(student.course_id)

        const matchedFees = feeStructure.filter(
          (fee) => fee.object_id === student.course_id,
        )
        setSelectedFeeStructure(matchedFees[0] || null)
      }
    }
  }, [student_id, course_id, students, feeStructure])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      if (!selectedCourse) return
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+`/get/student/by-course?course_id=${selectedCourse}`,
          { headers },
        )

        console.log('Students response: ', response.data.data)

        // setData(response.data.data)
        setStudents(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [selectedCourse])

  // Handle Course Selection

  const handleCourseChange = (e) => {
    const courseId = parseInt(e.target.value)
    setSelectedCourse(courseId)
    setSelectedFeeStructure('')
    setSelectedStudent('')

    console.log('✅ Selected Course ID:', courseId)
    console.log('📌 All Student Before Filtering:', students)
    console.log('📌 All Fee Structure Before Filtering:', feeStructure)
    const matchedFees = feeStructure.filter((fee) => fee.object_id === courseId)
    console.log('📌 Filtered Fee Structure:', matchedFees)

    setSelectedFeeStructure(matchedFees || null)
  }

  const handleFeeStructure = (e) => {
    const feeId = parseInt(e.target.value)
    console.log('✅ Selected Fee Structure ID:', feeId)

    const selectedFee = feeStructure.find((fee) => fee.id === feeId)

    setSelectedFeeStructure(selectedFee || null)
    console.log('✅ Selected Fee Structure:', selectedFee)
  }

  // Handle Student Selection
  const handleStudentChange = (e) => {
    setSelectedStudent(parseInt(e.target.value))
    console.log('✅ Selected Student ID:', e.target.value)
  }
  // const isOneTimeFee = () => {
  //   const name = selectedFeeStructure?.fee_name?.toLowerCase()
  //   return name === 'admission' || name === 'registration'
  // }

  const handleSave = async () => {
    if (!selectedStudent || !selectedFeeStructure) {
      toast.error('Please select both Student and Fee Structure.')
      return
    }

    if (Number(discount) > Number(selectedFeeStructure?.amount)) {
      toast.error('Discount cannot be greater than fee amount.')
      return
    }

    const requestData = {
      student_id: selectedStudent, // Correct Student ID
      fee_structure_id: selectedFeeStructure.id,
      discount: discount || '0',
    }

    console.log('🔹 Sending Data: ', requestData)

  // const userCookie = Cookies.get('user')
  // const instituteId = Cookies.get('institute_id')
  // let token = null

  // if (userCookie) {
  //   try {
  //     const user = JSON.parse(userCookie)
  //     token = user.token
  //   } catch (err) {
  //     console.error('Failed to parse user cookie', err)
  //   }
  // }

  // const headers = {
  //   'Content-Type': 'application/json',
  //   Authorization: `Bearer ${token}`,
  //   institute_id: Number(instituteId),
  // }
  //   console.log('🔹 Headers: ', headers)


    try {
      const response = await ApiEndpoints.addStudentApplyFees(requestData
        // , headers

      )
      console.log('✅ Applied Successfully:', response)
      toast.success('Fee applied successfully!')
      handleRefresh()
    } catch (error) {
      console.error('❌ Error Applying Fee:', error.response?.data)
      toast.error(error.response?.data?.result || 'Failed to apply fee.')
    }
  }

  const handleRefresh = () => {
    // Reset selected values to initial state
    setSelectedCourse('')
    setSelectedFeeStructure(null)
    setSelectedStudent('')
    // Reset filtered course data to the original courses list
    setFilteredCourse(courses)
    setCurrentStudent(null)
    navigate('/ApplyFees')
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">
            {' '}
            Apply Fees{' '}
            {currentStudent && (
              <>
                for <span className="text-warning">{currentStudent.name}</span>
              </>
            )}
          </h2>
        </div>
      </div>

      {/* Selection Box */}
      <Row className="g-2 align-items-end d-flex mt-3 flex-wrap text-start">
        <Col md={3}>
          <Form.Group controlId="courseId" classData="fw-bold mb-0">
            <Form.Label className="fw-bold text-dark">Course</Form.Label>
            {/* <Form.Select
              className="rounded-3"
              onChange={handleCourseChange}
              value={selectedCourse}
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({ target: { value: course.id } })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cs) => cs.id === Number(selectedCourse),
              )}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="studentId">
            <Form.Label className="fw-bold text-dark">Fee Structure</Form.Label>
            {/* <Form.Select
              className="rounded-3"
              onChange={handleFeeStructure}
              value={selectedFeeStructure ? selectedFeeStructure.id : ''}
            >
              <option value="">Select Fee Structure</option>
              {feeStructure
                .filter((fee) => fee.object_id === selectedCourse)
                .map((fee) => (
                  <option key={fee.id} value={fee.id}>
                    ₹ {fee.amount} -{' '}
                    {fee?.fee_name
                      ? fee.fee_name.charAt(0).toUpperCase() +
                        fee.fee_name.slice(1)
                      : 'N/A'}
                  </option>
                ))}
            </Form.Select> */}
            <Typeahead
              id="fee-structure-select"
              labelKey={(option) =>
                `₹ ${option.amount} - ${
                  option.fee_name
                    ? option.fee_name.charAt(0).toUpperCase() +
                      option.fee_name.slice(1)
                    : 'N/A'
                }`
              }
              onChange={(selected) => {
                const fee = selected[0]
                if (fee) {
                  handleFeeStructure({ target: { value: fee.id } })
                } else {
                  handleFeeStructure({ target: { value: '' } })
                }
              }}
              options={feeStructure.filter(
                (fee) => fee.object_id === selectedCourse,
              )}
              placeholder="Select Fee Structure"
              selected={
                selectedFeeStructure
                  ? feeStructure.filter(
                      (fee) => fee.id === selectedFeeStructure.id,
                    )
                  : []
              }
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="studentId">
            <Form.Label className="fw-bold text-black">Student</Form.Label>
            {/* <Form.Select
              className="rounded-3"
              onChange={handleStudentChange}
              value={selectedStudent}
            >
              <option value="">Select Student</option>
              {students.map((student) => (
                <option key={student.id} value={student.id}>
                  {student.name} - {student.admission_number}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="student-select"
              labelKey={(option) =>
                `${option.name} - ${option.admission_number}`
              }
              onChange={(selected) => {
                const student = selected[0]
                if (student) {
                  handleStudentChange({ target: { value: student.id } })
                } else {
                  handleStudentChange({ target: { value: '' } })
                }
              }}
              options={students}
              placeholder="Select Student"
              selected={students.filter(
                (st) => st.id === Number(selectedStudent),
              )}
            />
          </Form.Group>
        </Col>
        <Col className="d-flex justify-content-md-end justify-content-start">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>
      <div className="mt-4 text-start">
        <Card className="shadow-lg border-0 rounded-4 p-3 bg-white">
          <Card.Body className="p-4">
            <Row>
              <Col md={6}>
                {/* fee name*/}
                <Form.Group controlId="studentId" className="mb-3">
                  <Form.Label className="fw-bold text-dark">
                    Fee Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      selectedFeeStructure ? selectedFeeStructure.fee_name : ''
                    }
                    disabled
                    className="rounded-3"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                {/* Amount*/}
                <Form.Group controlId="courseId" className="mb-3">
                  <Form.Label className="fw-bold text-dark">Amount</Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      selectedFeeStructure
                        ? !selectedFeeStructure.amount
                          ? '₹ 0'
                          : `₹ ${selectedFeeStructure.amount}`
                        : ''
                    }
                    disabled
                    className="rounded-3"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              {/* Frequency */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-bold text-dark">
                    Frequency
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={
                      selectedFeeStructure
                        ? selectedFeeStructure.fee_frequency
                        : ''
                    }
                    disabled
                    className="rounded-3"
                  />
                </Form.Group>
              </Col>

              {/* Discount */}
              {/* <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold text-danger">
                        Discount
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="0"
                        className="rounded-3"
                      />
                    </Form.Group>
                  </Col> */}
              {/* {!isOneTimeFee() && ( */}
              <>
                <Col md={6}>
                  <Form.Group controlId="courseId" className="mb-3">
                    <Form.Label className="fw-bold text-dark">From</Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedStudent
                          ? (() => {
                              const student = students.find(
                                (s) => s.id === selectedStudent,
                              )
                              const classData = classes.find(
                                (c) => c.id === student?.class_id,
                              )
                              return classData?.start_date
                                ? new Date(
                                    classData.start_date,
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                  })
                                : 'N/A'
                            })()
                          : ''
                      }
                      disabled
                      className="rounded-3"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="" className="mb-3">
                    <Form.Label className="fw-bold text-dark">To</Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedStudent
                          ? (() => {
                              const student = students.find(
                                (s) => s.id === selectedStudent,
                              )
                              const classData = classes.find(
                                (c) => c.id === student?.class_id,
                              )
                              return classData?.end_date
                                ? new Date(
                                    classData.end_date,
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                  })
                                : 'N/A'
                            })()
                          : ''
                      }
                      disabled
                      className="rounded-3"
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Discount</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>₹</InputGroup.Text>
                      <Form.Control
                        type="number"
                        id="discount"
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)}
                        className="rounded-3"
                        placeholder="Enter discount"
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Form.Group className="mb-3">
                  <Form.Check
                    className="text-danger"
                    type="checkbox"
                    id="acknowledgeCheckbox"
                    label="I acknowledge and agree that this process is irreversible and cannot be undone."
                    checked={isAcknowledged}
                    onChange={(e) => setIsAcknowledged(e.target.checked)}
                  />
                </Form.Group>
              </>
              {/* )} */}
            </Row>

            {/* Apply Button */}
            <div className="d-grid">
              <Button
                variant="success"
                className="fw-bold rounded-3 mb-2 py-2"
                onClick={handleSave}
                disabled={!isAcknowledged}
              >
                Apply Fees
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
